import { jsx as r, jsxs as pt } from "react/jsx-runtime";
import { c as v } from "./index-65016bfa.mjs";
import at, { useState as q, useRef as it } from "react";
import K, { css as L, useTheme as lt } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as ut } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { D as f } from "./index-2be68378.mjs";
import { Icon as w } from "./icon.js";
import { I } from "./helperText-d9646f54.mjs";
import { TextInput as ct } from "./textInput.js";
import { u as E } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as mt } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./button.js";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./closeButton.js";
import "./iconButton.js";
import "@fcamna/shared-icons";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./menu.js";
import "./radio.js";
const B = "TextInput", st = K.div`
  &.InputAndSuggestionWrapper {
    ${({
  theme: {
    components: { search: u }
  }
}) => L(u.InputAndSuggWrapper)};
  }
`, F = K.div`
  &.IconWrapper {
    ${({
  theme: {
    components: { search: u }
  }
}) => L(u.IconWrapper)};
  }
`;
function zt({
  textSize: u = "medium",
  onChange: n,
  value: c = {
    inputValue: "",
    selectedValue: ""
  },
  limit: j = "5",
  pattern: dt,
  disabled: i,
  searchResults: o,
  label: k = "Label",
  // deprecated
  isRequired: D = !1,
  showRequiredIndicator: ft = D,
  //deprecated
  isInvalid: y = !1,
  helperText: O = "",
  required: b = D,
  helperTextProp: P = {
    [y ? "secondaryProp" : "defaultProp"]: {
      helperText: O,
      id: `${y ? "invalid" : "valid"}_${B}_helperText`,
      ...y && { state: "error" }
    }
  },
  onBlur: H,
  accessibilityOptions: U = {},
  labelProp: Q = { label: k },
  infoProp: X,
  trailingText: G,
  onSubmit: l,
  onSearchClick: A,
  //deprecated
  noResultText: J = "No result found",
  inputState: N,
  showSuggestionsNoInput: V = !1,
  exceedOverflow: Y = !1,
  menuDirection: Z = "down_auto",
  ...x
}) {
  var h;
  const C = ut({ label: "Search Input" }), [_, m] = q(!1), s = at.useRef(null), T = it(mt(x.id ?? B)), [$, W] = q(""), z = lt();
  let p = N || I.NONE, R = P;
  N || (p = y ? I.ERROR : I.NONE), P || (R = {
    [p === I.ERROR ? "secondaryProp" : "defaultProp"]: {
      helperText: O,
      id: `${p === I.ERROR ? "invalid" : "valid"}_${B}_helperText`,
      state: p
    }
  });
  const { clearButton: g, searchButton: S, ...tt } = U, et = E("combobox", {
    ...tt,
    ariaDisabled: i,
    ariaRequired: b,
    ariaInvalid: p === "caution" || p === "error",
    ariaHasPopup: "listbox",
    ariaControls: `list-${T.current}`,
    ariaExpanded: _
  }), rt = E("button", {
    ariaLabel: "clear",
    ...g
  }), ot = E("button", {
    ariaLabel: "search",
    ...S
  }), nt = (t) => {
    t.preventDefault();
    const e = t.currentTarget;
    W(e.value), n == null || n({
      inputValue: e.value,
      selectedValue: ""
    }), e.value.length > 0 || V ? m(!0) : m(!1);
  }, M = (t) => {
    t.stopPropagation(), s && s.current && s.current.focus(), n({
      inputValue: "",
      selectedValue: ""
    }), m(!1), W("");
  };
  return /* @__PURE__ */ r(
    st,
    {
      className: v(["InputAndSuggestionWrapper"]),
      ...C,
      children: /* @__PURE__ */ pt(
        f,
        {
          className: "no-filter",
          menuOpen: !i && _,
          onChange: (t, e) => {
            var d;
            n == null || n({
              inputValue: e.label,
              selectedValue: e.label
            }), l == null || l(t, e.label), (d = s.current) == null || d.focus(), W(e.label);
          },
          handleMenuOpen: (t) => m(t),
          isDisabled: i,
          exceedOverflow: Y,
          uniqueIdentifier: T.current,
          noResultText: J,
          maxItems: Number(j),
          closeOnSelect: !0,
          menuDirection: Z,
          children: [
            /* @__PURE__ */ r(f.Control, { children: /* @__PURE__ */ r(
              ct,
              {
                inputState: p,
                labelProp: { showRequiredIndicator: b, ...Q },
                infoProp: {
                  infoText: "",
                  infoType: "tooltip",
                  popupTipHeader: "Info",
                  ...X
                },
                startAdornmentProp: {
                  // as discussed with team, this need to be removed in future
                  onClick: (t) => {
                    A == null || A(t, $);
                  },
                  startAdornment: /* @__PURE__ */ r(
                    F,
                    {
                      className: v(["IconWrapper", { "IconWrapper--disabled": i }]),
                      ...ot,
                      tabIndex: -1,
                      children: /* @__PURE__ */ r(
                        w,
                        {
                          name: "search",
                          size: "s",
                          "aria-hidden": "true"
                        }
                      )
                    }
                  )
                },
                endAdornmentProp: {
                  endAdornment: c.inputValue && !i ? /* @__PURE__ */ r(
                    F,
                    {
                      className: v(["IconWrapper", "IconWrapper--CloseButtonWrapper"]),
                      onClick: M,
                      onKeyUp: (t) => {
                        (t.code === "Enter" || t.code === "Space") && (t.preventDefault(), t.stopPropagation(), M(t));
                      },
                      id: "closeButton",
                      ...rt,
                      children: /* @__PURE__ */ r(
                        w,
                        {
                          name: "cancelCloseFilled",
                          style: z.components.search.IconStyle
                        }
                      )
                    }
                  ) : void 0
                },
                onKeyUp: (t) => {
                  t.key === " " && t.stopPropagation();
                },
                value: c.inputValue,
                type: "text",
                textSize: u,
                required: b,
                inputRef: s,
                onChange: nt,
                disabled: i,
                placeholder: x.placeholder,
                onFocus: () => {
                  V && m(!0);
                },
                onBlur: H,
                onClick: (t) => {
                  t.stopPropagation(), t.preventDefault();
                },
                helperTextProp: _ ? {} : R,
                onKeyDown: (t) => {
                  t.key === "Enter" && (l == null || l(t, $));
                },
                trailingText: G,
                ...x,
                id: `control-${x.id || T.current}`,
                ...et
              }
            ) }),
            (((h = c == null ? void 0 : c.inputValue) == null ? void 0 : h.length) > 0 || V) && o && (o == null ? void 0 : o.length) > 0 && (o == null ? void 0 : o.map(({ label: t, hits: e }) => {
              const d = [
                t && /* @__PURE__ */ r(f.Title, { children: t }),
                !t && o.length > 1 && /* @__PURE__ */ r(f.Divider, {})
              ];
              return e.forEach(
                (a) => d.push(
                  /* @__PURE__ */ r(
                    f.Item,
                    {
                      id: a.value + a.label + a.subText,
                      label: a.label,
                      value: a.value,
                      description: a.subText
                    },
                    a.value
                  )
                )
              ), d;
            }))
          ]
        }
      )
    }
  );
}
export {
  zt as Search
};
